import { BrowserRouter, NavLink, Route, Routes } from 'react-router-dom';
import { useState } from 'react';
import CampaignsPage from './pages/CampaignsPage';
import CampaignDetailPage from './pages/CampaignDetailPage';
import GeneratePage from './pages/GeneratePage';
import DialerPage from './pages/DialerPage';
import Modal from './components/Modal';
import GenerateForm from './components/GenerateForm';
import CampaignForm from './components/CampaignForm';
import './App.css';

const IconBolt = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
  </svg>
);

const IconFolder = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 6h6l2 2h8v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
  </svg>
);

const IconPhone = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M6.6 2.8l3.1 1.2c.6.2.9.9.6 1.5l-1.3 2.6a16.1 16.1 0 0 0 6.9 6.9l2.6-1.3c.6-.3 1.3 0 1.5.6l1.2 3.1c.2.6-.1 1.2-.6 1.5-2 .9-4.2 1.4-6.4 1.2-6.6-.6-11.9-5.9-12.5-12.5-.2-2.2.3-4.4 1.2-6.4.3-.6.9-.8 1.5-.6z" />
  </svg>
);

const IconSpark = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2l1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8L12 2z" />
  </svg>
);

function App() {
  const [modal, setModal] = useState(null);

  return (
    <BrowserRouter>
      <div className="layout">
        <aside className="sidebar">
          <div className="brand">Lead Engine</div>

          <div className="sidebar-section">
            <p className="section-title">Core</p>
            <NavLink className="nav-item" to="/generate">
              <IconSpark />
              <span>Generate CSV</span>
            </NavLink>
            <NavLink className="nav-item" to="/campaigns">
              <IconFolder />
              <span>Campaigns</span>
            </NavLink>
            <NavLink className="nav-item" to="/dialer">
              <IconPhone />
              <span>Dialer</span>
            </NavLink>
          </div>

          <div className="sidebar-section">
            <p className="section-title">Quick Actions</p>
            <button className="nav-action" onClick={() => setModal('generate')}>
              <IconBolt />
              Generate CSV
            </button>
            <button className="nav-action" onClick={() => setModal('campaign')}>
              <IconFolder />
              New Campaign
            </button>
          </div>

          <div className="sidebar-footer">
            <div className="muted">MVP build</div>
          </div>
        </aside>

        <div className="page">
          <main className="content">
            <Routes>
              <Route path="/" element={<GeneratePage />} />
              <Route path="/generate" element={<GeneratePage />} />
              <Route path="/campaigns" element={<CampaignsPage />} />
              <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
              <Route path="/dialer" element={<DialerPage />} />
            </Routes>
          </main>
        </div>

        {modal === 'generate' && (
          <Modal title="Generate CSV" onClose={() => setModal(null)}>
            <GenerateForm compact />
          </Modal>
        )}
        {modal === 'campaign' && (
          <Modal title="Create Campaign" onClose={() => setModal(null)}>
            <CampaignForm compact />
          </Modal>
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
